/**
 * Sets up a navigation guard for Vue pages rendered inside the Angular Backstage router.
 *
 * - Blocks angular route changes via `$routeChangeStart`.
 * - Warns on refresh/tab close via `beforeunload`.
 */
export function setUpAngularUnsavedChangesWarning({
    isDirty,
    warningText,
    bodyElement = document.body,
}) {
    let removeRouterListener = null;

    const angularRootScope = globalThis.angular?.element?.(bodyElement)?.scope?.()?.$root;
    if (angularRootScope?.$on) {
        removeRouterListener = angularRootScope.$on('$routeChangeStart', (event) => {
            if (!isDirty()) {
                return;
            }

            const confirmed = globalThis.confirm(warningText);
            if (event && !confirmed) {
                event.preventDefault();
            }
        });
    }

    /** @param {BeforeUnloadEvent} event */
    const browserCloseHandler = (event) => {
        if (!isDirty()) {
            return;
        }

        // Chrome requires returnValue to be set.
        event.returnValue = '';
        event.preventDefault();
    };

    globalThis.addEventListener('beforeunload', browserCloseHandler);

    return () => {
        globalThis.removeEventListener('beforeunload', browserCloseHandler);
        if (typeof removeRouterListener === 'function') {
            removeRouterListener();
        }
    };
}
